var e={wrapper:"Switcher__wrapper-mmX",labelText:"Switcher__labelText-0r8",switcher:"Switcher__switcher-eRf",active:"Switcher__active-i3x"};export{e as default};
